export default __webpack_public_path__ + "static/media/WPP_logo_horizontal.f323eaae.png";